import { userService } from "../services";
import config from "../config/config";

const TRIP_BASE = "http://192.168.60.242:8089";

const getBaseUrl = () =>
    JSON.parse(localStorage.getItem("config"))?.baseUrl ||
    TRIP_BASE;

export const TripsActionV2 = {
    getTripList,
    addTrip,
    updateTrip,
    deleteTrip,
    getTripById,
    startTrip,
    endTrip,
    checkTripValidation,
    lockUnlockTrip,
    getTripTrails,
    getSystemTrips,
    getLockUnlockReports,
    exportLockUnlockReport,
    exportLockTripsReport,
    forceCompleteTrip,
    requestBluetoothUnlock,
    rebootDigitalLock
};

async function getSystemTrips({ pageNo = 0, pageSize = 10, userId, gpsRefId, lockId, fromDate, toDate, status } = {}) {
    try {
        const apiEndpoint = `${getBaseUrl()}api/e-lock/system-trips/get/all`;
        const response = await userService.post(apiEndpoint, {
            userId,
            gpsRefId,
            lockId,
            fromDate,
            toDate,
            status: status ? status.toUpperCase() : null,
            pageNo,
            pageSize
        });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("getSystemTrips error", error);
        return null;
    }
}
async function getTripList({ pageNo = 0, pageSize = 10, keyword = "", isActive = null, sourceId = null, destinationId = null, lockId = null, tripType = null,
    fromDate = null, toDate = null, etaStatus = null,isScmTrip = false
} = {}) {
    const data =
    {

        "ForDashBoard": true,
        "pageNo": pageNo,
        "pageSize": pageSize,
        "companyId": 1,
        userId: JSON.parse(localStorage.getItem("data")).id,
        "destinationGeofenceId": destinationId,
        "sourceGeofenceId": sourceId,
        fromDate,
        toDate,
        "tripStatus": null,
        "tripTimeStatus": null,
        "vehicleNumber": null,
        keyword, lockId, tripType,
        etaStatus: etaStatus ? etaStatus : null,
        isScmTrip,
        "tripStatusList": isActive
            ? [isActive.toUpperCase()]
            : ["COMPLETED", "IN_PROGRESS", "PENDING", "MISSED", "HALT","CANCELLED"]
    }
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2GetAll}?pageNo=${pageNo}&pageSize=${pageSize}`;
        const response = await userService.post(apiEndpoint, data);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("getTripList error", error);
        return null;
    }
}

async function getTripById(tripId) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2ById}?orderId=${tripId}&companyId=1`;
        const response = await userService.get(apiEndpoint);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("getTripById error", error);
        return null;
    }
}

async function addTrip(payload,type) {
    try {
        const sufix= type==="SCM" ? config.apiName.SCMTripAdd:config.apiName.TripV2Add
         const apiEndpoint = `${getBaseUrl()}${sufix}`;
        const response = await userService.post(apiEndpoint, payload);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("addTrip error", error);
        return null;
    }
}

async function updateTrip(payload) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2Update}`;
        const response = await userService.post(apiEndpoint, payload);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("updateTrip error", error);
        return null;
    }
}

async function deleteTrip({ tripId, reason }) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2DeleteManual}`;
        const response = await userService.post(apiEndpoint, { tripId, reason });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("deleteTrip error", error);
        return null;
    }
}

async function startTrip(tripId) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2StartManual}`;
        const response = await userService.post(apiEndpoint, { tripId });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("startTrip error", error);
        return null;
    }
}
async function endTrip(tripId) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2End}/${tripId}`;
        const response = await userService.post(apiEndpoint, {});
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("endTrip error", error);
        return null;
    }
}

async function checkTripValidation({ lockNumber, vehicleNumber, vehicleId, sourceGeofenceId }) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config.apiName.TripV2CheckValidation}`;
        const response = await userService.post(apiEndpoint, {
            lockNumber,
            vehicleNumber,
            vehicleId,
            sourceGeofenceId
        });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("checkTripValidation error", error);
        return null;
    }
}

// In TripsActionV2.js:

async function lockUnlockTrip({ id, isCompletionTrip, isOpenCloseLock, reason, evidenceImages, lockNumber }) {
    try {
        const apiEndpoint = `${getBaseUrl()}api/elock/complete/manual/trip`;
        const response = await userService.post(apiEndpoint, {
            id,
            lockNumber,
            isCompletionTrip,
            isOpenCloseLock,
            reason,
            evidenceImages
        });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("lockUnlockTrip error", error);
        return null;
    }
}

async function rebootDigitalLock(payload) {
    try {
        const apiEndpoint = `${getBaseUrl()}${config?.apiName?.rebootDigilock}`;
        const response = await userService.post(apiEndpoint, payload);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("reboot digilock error", error);
        return null;
    }
}

async function getTripTrails(tripId) {
    try {
        const apiEndpoint = `${getBaseUrl()}api/elock/get/lock/trails?tripId=${tripId}`;
        const response = await userService.get(apiEndpoint);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("getTripTrails error", error);
        return null;
    }
}



async function getLockUnlockReports({
    lockId,
    fromDate,
    toDate,
    pageNo = 0,
    pageSize = 10,
    userId
}) {
    try {
        const apiEndpoint = `${getBaseUrl()}api/e-lock/system-trips/get/all/trails?lockId=${lockId}&fromDate=${fromDate}&toDate=${toDate}&pageNo=${pageNo}&pageSize=${pageSize}&userId=${userId}`;
        const response = await userService.get(apiEndpoint);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.error("getLockUnlockReports error", error);
        return null;
    }
}

async function exportLockUnlockReport(payload) {
    try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const baseUrl = getBaseUrl();
        const response = await fetch(
            `${baseUrl}api/${config.apiName.DigitalLockUnlockExport}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const responseText = await response.text();
        return responseText;
    } catch (error) {
        console.error("exportLockUnlockReport error", error);
        return null;
    }
}

async function exportLockTripsReport(payload, tripType) {
    try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const baseUrl = getBaseUrl();
        const response = await fetch(
            `${baseUrl}api/${config.apiName.LockTripsExport}?type=${tripType}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const responseText = await response.text();
        return responseText;
    } catch (error) {
        console.error("exportLockTripsReport error", error);
        return null;
    }
}

async function forceCompleteTrip({ id, reason }) {
    try {
        const apiEndpoint = `${getBaseUrl()}api/elock/forcefully/complete/trip`;
        const response = await userService.post(apiEndpoint, {
            id,
            reason,
            evidenceImages: null
        });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("forceCompleteTrip error", error);
        return null;
    }
}

async function requestBluetoothUnlock({ lockNumber, isThroughBluetooth = true }) {
    try {
        const apiEndpoint = `${getBaseUrl()}api/elock/complete/manual/trip`;
        const response = await userService.post(apiEndpoint, {
            lockNumber,
            isThroughBluetooth,
        });
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("requestBluetoothUnlock error", error);
        return null;
    }
}